import { Injectable } from '@angular/core';

import { EPSG, EPSGMapping } from '../epsg';
import { ResultPage } from '../result-page';
import { Adapter } from './adapter';

@Injectable({
    providedIn: 'root',
})
/**
 * Adapts the result of the EPSG search
 */
export class EpsgAdapterService implements Adapter<ResultPage<EPSG>> {
    adapt(item: any): ResultPage<EPSG> {
        return {
            count: item.number_result,
            next: (item.currentPage + 1).toString(),
            previous: (item.currentPage - 1).toString(),
            results: this.adaptResults(item.results),
        };
    }

    private adaptResults(results: any): EPSG[] {
        return results.map((result: any) => {
            return {
                code: result.code,
                name: this.parseRomanNumbers(result),
            };
        });
    }

    /**
     * Converts all Roman numbers found in an array of EPSG objects to Arabic.
     */

    private parseRomanNumbers(result: EPSG): string {
        const lastIndex = result.name.lastIndexOf(' ') + 1;
        const romanNumberCandidate = result.name.substring(lastIndex);

        if (!this.isRoman(romanNumberCandidate)) {
            return result.name;
        }

        return `${result.name.substring(0, lastIndex)}${this.toArabic(romanNumberCandidate).toFixed(0)}`;
    }
    /**
     * Checks if a number is in Roman format.
     */

    private isRoman(num: string): boolean {
        const regExp = new RegExp(/[^MDCLXVI]|D[M]|D{2,}|C{4,}|L[^XVI]|L{2,}|X[MD]|X{4,}|V[^I]|V{2,}|I[^XVI]|I{4,}|IV[IVX]|IX[IVX]/);
        return regExp.test(num) || num === '' ? false : true;
    }

    /**
     * Utility function that converts Roman numbers to Arabic.
     */
    private toArabic(data: string): number {
        const MAPPINGS: EPSGMapping = {
            M: 1000,
            D: 500,
            C: 100,
            L: 50,
            X: 10,
            V: 5,
            I: 1,
        };
        const dataSplitted = data.split('');
        let result = 0;

        for (const [index] of dataSplitted.entries()) {
            if (MAPPINGS[dataSplitted[index]] < MAPPINGS[dataSplitted[index + 1]]) {
                result -= MAPPINGS[dataSplitted[index]];
            } else {
                result += MAPPINGS[dataSplitted[index]];
            }
        }

        return result > 9000 ? +data : result;
    }
}
